import { useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Services from "@/components/Services";
import SmallBusiness from "@/components/SmallBusiness";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import MapSection from "@/components/MapSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { scrollToSection } from "@/lib/scroll";

export default function Landing() {
    const [prefill, setPrefill] = useState(null);

    const handleEnquire = (selectValue) => {
        setPrefill({ value: selectValue, key: Date.now() });
        scrollToSection("#contact");
    };

    return (
        <div className="site" id="top">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Problem />
                <Services onEnquire={handleEnquire} />
                <SmallBusiness onEnquire={handleEnquire} />
                <HowItWorks />
                <About />
                <MapSection />
                <Contact prefill={prefill} />
            </main>
            <Footer />
        </div>
    );
}
